<template>
  <div class="br-pagebody pd-x-20 pd-sm-x-30 distributor-page">
    <div>
      <div class="list-wrap mg-b-15">
        <div class="list-heard d-flex mg-b-5">
          <div class="d-flex justify-content-center">
            <label class="ckbox mg-b-0">
              <input
                type="checkbox"
                :checked="allCheck"
                @change="allCheckChange"
              />
              <span></span>
            </label>
          </div>
          <div class="d-flex pd-x-5 flex-1 tx-white">
            <div class="c-10">
              {{ $t("mall.标签名称") }}
            </div>
            <div class="c-5">
              {{ $t("mall.已绑定商品数") }}
            </div>
            <div class="c-5">
              {{ $t("mall.是否在商城显示") }}
            </div>
            <div class="c-4">
              {{ $t("mall.操作") }}
            </div>
          </div>
        </div>
        <!--$t('mall.名字和状态搜索')-->
        <template v-if="keyName && keyStatus">
          <template v-if="keyStatus == 1">
            <template v-for="(item, index) in items">
              <div
                :key="item.id + index"
                v-if="item.isShow == 1 && item.keyNameShow"
                class="list-body d-flex align-items-start mg-b-10"
              >
                <div class="d-flex justify-content-center">
                  <label class="ckbox mg-b-0">
                    <input
                      type="checkbox"
                      :value="item.id"
                      v-model="checkArr"
                    />
                    <span></span>
                  </label>
                </div>
                <div class="flex-1 pd-x-0 mg-x-5">
                  <div class="card bd-gray-400 pd-5">
                    <div
                      class="
                        d-flex
                        flex-row
                        align-items-center
                        justify-content-start
                      "
                    >
                      <div class="c-10">
                        <span
                          class="tx-white tx-ellipsis2"
                          style="
                            max-width: 100%;
                            display: inline-block;
                            word-break: break-all;
                          "
                          >{{ item.name }}</span
                        >
                        <div
                          class="td-collapse mg-t-10"
                          :class="{ active: openInner[index] }"
                        >
                          <a
                            href="javascript:;"
                            class="tx-info"
                            @click="innerTableStatus(index)"
                          >
                            <i
                              class="fa tx-white"
                              :class="
                                openInner[index]
                                  ? 'fa-minus-square'
                                  : 'fa-plus-square'
                              "
                            ></i>
                            {{
                              openInner[index]
                                ? $t("mall.折叠子标签")
                                : $t("mall.展开子标签")
                            }}
                          </a>
                        </div>
                      </div>
                      <div class="c-5" style="padding-left: 20px">
                        <a
                          v-if="item.skuCnt > 0"
                          href="javascript:;"
                          class="tx-info"
                          @click="getProductByCid(item)"
                          >{{ item.skuCnt }}</a
                        >
                        <a v-else href="javascript:;" class="tx-info">0</a>
                      </div>
                      <div v-if="item.id != 999999999" class="c-5">
                        <a
                          style="height: 26px"
                          href="javascript:;"
                          class="toggle-wrapper"
                          @click="togglesChange(item)"
                          :class="{ toggles_on: item.isShow == 1 }"
                        >
                          <div class="toggle toggle-light primary">
                            <div class="toggle-slide">
                              <div class="toggle-inner">
                                <div class="toggle-on">{{ $t("mall.是") }}</div>
                                <div class="toggle-blob"></div>
                                <div class="toggle-off">
                                  {{ $t("mall.否") }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </a>
                      </div>
                      <div class="c-4">
                        <template v-if="item.id != 999999999">
                          <div>
                            <a
                              href="javascript:;"
                              class="tx-info mg-r-15"
                              @click="move(item, '1')"
                              >{{ $t("mall.上移") }}</a
                            >
                            <a
                              href="javascript:;"
                              class="tx-info mg-r-15"
                              @click="move(item, '2')"
                              >{{ $t("mall.下移") }}</a
                            >
                            <a
                              v-if="
                                isSysRights(
                                  'SupplierProductCategorys.changeBySupplier'
                                )
                              "
                              href="javascript:;"
                              class="tx-info"
                              @click="addNew(item)"
                              >{{ $t("mall.修改") }}</a
                            >
                          </div>
                          <div>
                            <a
                              href="javascript:;"
                              class="tx-info mg-r-15"
                              @click="addNew(item, 'sub')"
                              >{{ $t("mall.添加子标签") }}</a
                            >
                            <a
                              v-if="
                                isSysRights(
                                  'SupplierProductCategorys.deleteBySupplier'
                                )
                              "
                              href="javascript:;"
                              class="tx-danger"
                              @click="deletes(item)"
                              >{{ $t("mall.删除") }}</a
                            >
                          </div>
                          <div>
                            <a
                              v-if="
                                isSysRights(
                                  'SupplierProductCategorys.copyByCid'
                                )
                              "
                              href="javascript:;"
                              class="tx-info"
                              @click="addLabel(item)"
                              >{{ $t("mall.复制商品到其他标签") }}</a
                            >
                          </div>
                        </template>
                      </div>
                    </div>
                    <div>
                      <div
                        v-if="item.chlidren && item.chlidren.length > 0"
                        :style="{
                          display: openInner[index] ? 'block' : 'none',
                        }"
                      >
                        <div class="">
                          <template
                            v-for="(stock, stockIndex) in item.chlidren"
                          >
                            <div
                              class="order-pro bg-sub mg-t-5 mg-l-20"
                              :key="stock.id"
                              v-if="stock.isShow == 1"
                            >
                              <div
                                :class="{ 'bg-sub2': stockIndex % 2 }"
                                class="
                                  bg-sub1
                                  pd-y-5
                                  d-flex
                                  flex-row
                                  align-items-center
                                  justify-content-start
                                  pos-relative
                                "
                              >
                                <div class="c-10 d-flex align-items-center">
                                  <span class="tx-white">{{ stock.name }}</span>
                                </div>
                                <div class="c-5">
                                  <a
                                    v-if="stock.skuCnt > 0"
                                    href="javascript:;"
                                    class="tx-info"
                                    @click="getProductByCid(stock)"
                                    >{{ stock.skuCnt }}</a
                                  >
                                  <a v-else href="javascript:;" class="tx-info"
                                    >0</a
                                  >
                                </div>
                                <div class="c-5">
                                  <a
                                    v-if="item.isShow == 1"
                                    style="height: 26px"
                                    href="javascript:;"
                                    class="toggle-wrapper"
                                    @click="togglesChange(stock)"
                                    :class="{ toggles_on: stock.isShow == 1 }"
                                  >
                                    <div class="toggle toggle-light primary">
                                      <div class="toggle-slide">
                                        <div class="toggle-inner">
                                          <div class="toggle-on">
                                            {{ $t("mall.是") }}
                                          </div>
                                          <div class="toggle-blob"></div>
                                          <div class="toggle-off">
                                            {{ $t("mall.否") }}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </a>
                                </div>
                                <div class="c-4">
                                  <div>
                                    <a
                                      href="javascript:;"
                                      class="tx-info mg-r-30"
                                      @click="move(stock, '1')"
                                      >{{ $t("mall.上移") }}</a
                                    >
                                    <a
                                      href="javascript:;"
                                      class="tx-info"
                                      @click="move(stock, '2')"
                                      >{{ $t("mall.下移") }}</a
                                    >
                                  </div>
                                  <div>
                                    <a
                                      v-if="
                                        isSysRights(
                                          'SupplierProductCategorys.changeBySupplier'
                                        )
                                      "
                                      href="javascript:;"
                                      class="tx-info mg-r-30"
                                      @click="editSub(item, stock)"
                                      >{{ $t("mall.修改") }}</a
                                    >
                                    <a
                                      v-if="
                                        isSysRights(
                                          'SupplierProductCategorys.deleteBySupplier'
                                        )
                                      "
                                      href="javascript:;"
                                      class="tx-danger"
                                      @click="deletes(stock)"
                                      >{{ $t("mall.删除") }}</a
                                    >
                                  </div>
                                  <div>
                                    <a
                                      v-if="
                                        isSysRights(
                                          'SupplierProductCategorys.copyByCid'
                                        )
                                      "
                                      href="javascript:;"
                                      class="tx-info"
                                      @click="addLabel(stock)"
                                      >{{ $t("mall.复制商品到其他标签") }}</a
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                          </template>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <div
              v-if="isShowFLag1 == 0 && isShowFLag3 == 0 && !first_loading"
              class="col-12 none-product"
            >
              <i class="fa fa-ban"></i>{{ $t("mall.没有符合条件的标签") }}
            </div>
          </template>
          <template v-else-if="keyStatus == 2">
            <template v-for="(item, index) in items">
              <div
                :key="item.id + index"
                v-if="item.isShow == 2 && item.keyNameShow"
                class="list-body d-flex align-items-start mg-b-10"
              >
                <div class="d-flex justify-content-center">
                  <label class="ckbox mg-b-0">
                    <input
                      type="checkbox"
                      :value="item.id"
                      v-model="checkArr"
                    />
                    <span></span>
                  </label>
                </div>
                <div class="flex-1 pd-x-0 mg-x-5">
                  <div class="card bd-gray-400 pd-5">
                    <div
                      class="
                        d-flex
                        flex-row
                        align-items-center
                        justify-content-start
                      "
                    >
                      <div class="c-10">
                        <span
                          class="tx-white tx-ellipsis2"
                          style="
                            max-width: 100%;
                            display: inline-block;
                            word-break: break-all;
                          "
                          >{{ item.name }}</span
                        >
                        <div
                          class="td-collapse mg-t-10"
                          :class="{ active: openInner[index] }"
                        >
                          <a
                            href="javascript:;"
                            class="tx-info"
                            @click="innerTableStatus(index)"
                          >
                            <i
                              class="fa tx-white"
                              :class="
                                openInner[index]
                                  ? 'fa-minus-square'
                                  : 'fa-plus-square'
                              "
                            ></i>
                            {{
                              openInner[index]
                                ? $t("mall.折叠子标签")
                                : $t("mall.展开子标签")
                            }}
                          </a>
                        </div>
                      </div>
                      <div class="c-5" style="padding-left: 20px">
                        <a
                          v-if="item.skuCnt > 0"
                          href="javascript:;"
                          class="tx-info"
                          @click="getProductByCid(item)"
                          >{{ item.skuCnt }}</a
                        >
                        <a v-else href="javascript:;" class="tx-info">0</a>
                      </div>
                      <div v-if="item.id != 999999999" class="c-5">
                        <a
                          style="height: 26px"
                          href="javascript:;"
                          class="toggle-wrapper"
                          @click="togglesChange(item)"
                          :class="{ toggles_on: item.isShow == 1 }"
                        >
                          <div class="toggle toggle-light primary">
                            <div class="toggle-slide">
                              <div class="toggle-inner">
                                <div class="toggle-on">{{ $t("mall.是") }}</div>
                                <div class="toggle-blob"></div>
                                <div class="toggle-off">
                                  {{ $t("mall.否") }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </a>
                      </div>
                      <div v-if="item.id != 999999999" class="c-4">
                        <div>
                          <a
                            href="javascript:;"
                            class="tx-info mg-r-15"
                            @click="move(item, '1')"
                            >{{ $t("mall.上移") }}</a
                          >
                          <a
                            href="javascript:;"
                            class="tx-info mg-r-15"
                            @click="move(item, '2')"
                            >{{ $t("mall.下移") }}</a
                          >
                          <a
                            v-if="
                              isSysRights(
                                'SupplierProductCategorys.changeBySupplier'
                              )
                            "
                            href="javascript:;"
                            class="tx-info"
                            @click="addNew(item)"
                            >{{ $t("mall.修改") }}</a
                          >
                        </div>
                        <div>
                          <a
                            href="javascript:;"
                            class="tx-info mg-r-15"
                            @click="addNew(item, 'sub')"
                            >{{ $t("mall.添加子标签") }}</a
                          >
                          <a
                            v-if="
                              isSysRights(
                                'SupplierProductCategorys.deleteBySupplier'
                              )
                            "
                            href="javascript:;"
                            class="tx-danger"
                            @click="deletes(item)"
                            >{{ $t("mall.删除") }}</a
                          >
                        </div>
                        <div>
                          <a
                            v-if="
                              isSysRights('SupplierProductCategorys.copyByCid')
                            "
                            href="javascript:;"
                            class="tx-info"
                            @click="addLabel(item)"
                            >{{ $t("mall.复制商品到其他标签") }}</a
                          >
                        </div>
                      </div>
                    </div>
                    <div>
                      <div
                        v-if="item.chlidren && item.chlidren.length > 0"
                        :style="{
                          display: openInner[index] ? 'block' : 'none',
                        }"
                      >
                        <div class="">
                          <template
                            v-for="(stock, stockIndex) in item.chlidren"
                          >
                            <div
                              class="order-pro bg-sub mg-t-5 mg-l-20"
                              :key="stock.id"
                              v-if="stock.isShow == 2"
                            >
                              <div
                                :class="{ 'bg-sub2': stockIndex % 2 }"
                                class="
                                  bg-sub1
                                  pd-y-5
                                  d-flex
                                  flex-row
                                  align-items-center
                                  justify-content-start
                                  pos-relative
                                "
                              >
                                <div class="c-10 d-flex align-items-center">
                                  <span class="tx-white">{{ stock.name }}</span>
                                </div>
                                <div class="c-5">
                                  <a
                                    v-if="stock.skuCnt > 0"
                                    href="javascript:;"
                                    class="tx-info"
                                    @click="getProductByCid(stock)"
                                    >{{ stock.skuCnt }}</a
                                  >
                                  <a v-else href="javascript:;" class="tx-info"
                                    >0</a
                                  >
                                </div>
                                <div class="c-5">
                                  <a
                                    v-if="item.isShow == 1"
                                    style="height: 26px"
                                    href="javascript:;"
                                    class="toggle-wrapper"
                                    @click="togglesChange(stock)"
                                    :class="{ toggles_on: stock.isShow == 1 }"
                                  >
                                    <div class="toggle toggle-light primary">
                                      <div class="toggle-slide">
                                        <div class="toggle-inner">
                                          <div class="toggle-on">
                                            {{ $t("mall.是") }}
                                          </div>
                                          <div class="toggle-blob"></div>
                                          <div class="toggle-off">
                                            {{ $t("mall.否") }}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </a>
                                </div>
                                <div class="c-4">
                                  <div>
                                    <a
                                      href="javascript:;"
                                      class="tx-info mg-r-30"
                                      @click="move(stock, '1')"
                                      >{{ $t("mall.上移") }}</a
                                    >
                                    <a
                                      href="javascript:;"
                                      class="tx-info"
                                      @click="move(stock, '2')"
                                      >{{ $t("mall.下移") }}</a
                                    >
                                  </div>
                                  <div>
                                    <a
                                      v-if="
                                        isSysRights(
                                          'SupplierProductCategorys.changeBySupplier'
                                        )
                                      "
                                      href="javascript:;"
                                      class="tx-info mg-r-30"
                                      @click="editSub(item, stock)"
                                      >{{ $t("mall.修改") }}</a
                                    >
                                    <a
                                      v-if="
                                        isSysRights(
                                          'SupplierProductCategorys.deleteBySupplier'
                                        )
                                      "
                                      href="javascript:;"
                                      class="tx-danger"
                                      @click="deletes(stock)"
                                      >{{ $t("mall.删除") }}</a
                                    >
                                  </div>
                                  <div>
                                    <a
                                      v-if="
                                        isSysRights(
                                          'SupplierProductCategorys.copyByCid'
                                        )
                                      "
                                      href="javascript:;"
                                      class="tx-info"
                                      @click="addLabel(stock)"
                                      >{{ $t("mall.复制商品到其他标签") }}</a
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                          </template>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <div
              v-if="isShowFLag2 == 0 && isShowFLag3 == 0 && !first_loading"
              class="col-12 none-product"
            >
              <i class="fa fa-ban"></i>{{ $t("mall.没有符合条件的标签") }}
            </div>
          </template>
        </template>
        <!--$t('mall.名字或者状态搜索')-->
        <template v-if="keyName || keyStatus">
          <template v-if="keyStatus == 1">
            <template v-for="(item, index) in items">
              <div
                :key="item.id + index"
                v-if="item.isShow == 1"
                class="list-body d-flex align-items-start mg-b-10"
              >
                <div class="d-flex justify-content-center">
                  <label class="ckbox mg-b-0">
                    <input
                      type="checkbox"
                      :value="item.id"
                      v-model="checkArr"
                    />
                    <span></span>
                  </label>
                </div>
                <div class="flex-1 pd-x-0 mg-x-5">
                  <div class="card bd-gray-400 pd-5">
                    <div
                      class="
                        d-flex
                        flex-row
                        align-items-center
                        justify-content-start
                      "
                    >
                      <div class="c-10">
                        <span
                          class="tx-white tx-ellipsis2"
                          style="
                            max-width: 100%;
                            display: inline-block;
                            word-break: break-all;
                          "
                          >{{ item.name }}</span
                        >
                        <div
                          class="td-collapse mg-t-10"
                          :class="{ active: openInner[index] }"
                        >
                          <a
                            href="javascript:;"
                            class="tx-info"
                            @click="innerTableStatus(index)"
                          >
                            <i
                              class="fa tx-white"
                              :class="
                                openInner[index]
                                  ? 'fa-minus-square'
                                  : 'fa-plus-square'
                              "
                            ></i>
                            {{
                              openInner[index]
                                ? $t("mall.折叠子标签")
                                : $t("mall.展开子标签")
                            }}
                          </a>
                        </div>
                      </div>
                      <div class="c-5" style="padding-left: 20px">
                        <a
                          v-if="item.skuCnt > 0"
                          href="javascript:;"
                          class="tx-info"
                          @click="getProductByCid(item)"
                          >{{ item.skuCnt }}</a
                        >
                        <a v-else href="javascript:;" class="tx-info">0</a>
                      </div>
                      <div v-if="item.id != 999999999" class="c-5">
                        <a
                          style="height: 26px"
                          href="javascript:;"
                          class="toggle-wrapper"
                          @click="togglesChange(item)"
                          :class="{ toggles_on: item.isShow == 1 }"
                        >
                          <div class="toggle toggle-light primary">
                            <div class="toggle-slide">
                              <div class="toggle-inner">
                                <div class="toggle-on">{{ $t("mall.是") }}</div>
                                <div class="toggle-blob"></div>
                                <div class="toggle-off">
                                  {{ $t("mall.否") }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </a>
                      </div>
                      <div v-if="item.id != 999999999" class="c-4">
                        <div>
                          <a
                            href="javascript:;"
                            class="tx-info mg-r-15"
                            @click="move(item, '1')"
                            >{{ $t("mall.上移") }}</a
                          >
                          <a
                            href="javascript:;"
                            class="tx-info mg-r-15"
                            @click="move(item, '2')"
                            >{{ $t("mall.下移") }}</a
                          >
                          <a
                            v-if="
                              isSysRights(
                                'SupplierProductCategorys.changeBySupplier'
                              )
                            "
                            href="javascript:;"
                            class="tx-info"
                            @click="addNew(item)"
                            >{{ $t("mall.修改") }}</a
                          >
                        </div>
                        <div>
                          <a
                            href="javascript:;"
                            class="tx-info mg-r-15"
                            @click="addNew(item, 'sub')"
                            >{{ $t("mall.添加子标签") }}</a
                          >
                          <a
                            v-if="
                              isSysRights(
                                'SupplierProductCategorys.deleteBySupplier'
                              )
                            "
                            href="javascript:;"
                            class="tx-danger"
                            @click="deletes(item)"
                            >{{ $t("mall.删除") }}</a
                          >
                        </div>
                        <div>
                          <a
                            v-if="
                              isSysRights('SupplierProductCategorys.copyByCid')
                            "
                            href="javascript:;"
                            class="tx-info"
                            @click="addLabel(item)"
                            >{{ $t("mall.复制商品到其他标签") }}</a
                          >
                        </div>
                      </div>
                    </div>
                    <div>
                      <div
                        v-if="item.chlidren && item.chlidren.length > 0"
                        :style="{
                          display: openInner[index] ? 'block' : 'none',
                        }"
                      >
                        <div class="">
                          <template
                            v-for="(stock, stockIndex) in item.chlidren"
                          >
                            <div
                              class="order-pro bg-sub mg-t-5 mg-l-20"
                              :key="stock.id"
                              v-if="stock.isShow == 1"
                            >
                              <div
                                :class="{ 'bg-sub2': stockIndex % 2 }"
                                class="
                                  bg-sub1
                                  pd-y-5
                                  d-flex
                                  flex-row
                                  align-items-center
                                  justify-content-start
                                  pos-relative
                                "
                              >
                                <div class="c-10 d-flex align-items-center">
                                  <span class="tx-white">{{ stock.name }}</span>
                                </div>
                                <div class="c-5">
                                  <a
                                    v-if="stock.skuCnt > 0"
                                    href="javascript:;"
                                    class="tx-info"
                                    @click="getProductByCid(stock)"
                                    >{{ stock.skuCnt }}</a
                                  >
                                  <a v-else href="javascript:;" class="tx-info"
                                    >0</a
                                  >
                                </div>
                                <div class="c-5">
                                  <a
                                    v-if="item.isShow == 1"
                                    style="height: 26px"
                                    href="javascript:;"
                                    class="toggle-wrapper"
                                    @click="togglesChange(stock)"
                                    :class="{ toggles_on: stock.isShow == 1 }"
                                  >
                                    <div class="toggle toggle-light primary">
                                      <div class="toggle-slide">
                                        <div class="toggle-inner">
                                          <div class="toggle-on">
                                            {{ $t("mall.是") }}
                                          </div>
                                          <div class="toggle-blob"></div>
                                          <div class="toggle-off">
                                            {{ $t("mall.否") }}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </a>
                                </div>
                                <div class="c-4">
                                  <div>
                                    <a
                                      href="javascript:;"
                                      class="tx-info mg-r-30"
                                      @click="move(stock, '1')"
                                      >{{ $t("mall.上移") }}</a
                                    >
                                    <a
                                      href="javascript:;"
                                      class="tx-info"
                                      @click="move(stock, '2')"
                                      >{{ $t("mall.下移") }}</a
                                    >
                                  </div>
                                  <div>
                                    <a
                                      v-if="
                                        isSysRights(
                                          'SupplierProductCategorys.changeBySupplier'
                                        )
                                      "
                                      href="javascript:;"
                                      class="tx-info mg-r-30"
                                      @click="editSub(item, stock)"
                                      >{{ $t("mall.修改") }}</a
                                    >
                                    <a
                                      v-if="
                                        isSysRights(
                                          'SupplierProductCategorys.deleteBySupplier'
                                        )
                                      "
                                      href="javascript:;"
                                      class="tx-danger"
                                      @click="deletes(stock)"
                                      >{{ $t("mall.删除") }}</a
                                    >
                                  </div>
                                  <div>
                                    <a
                                      v-if="
                                        isSysRights(
                                          'SupplierProductCategorys.copyByCid'
                                        )
                                      "
                                      href="javascript:;"
                                      class="tx-info"
                                      @click="addLabel(stock)"
                                      >{{ $t("mall.复制商品到其他标签") }}</a
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                          </template>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <div
              v-if="isShowFLag1 == 0 && !first_loading"
              class="col-12 none-product"
            >
              <i class="fa fa-ban"></i>{{ $t("mall.没有符合条件的标签") }}
            </div>
          </template>
          <template v-else-if="keyStatus == 2">
            <template v-for="(item, index) in items">
              <div
                :key="item.id + index"
                v-if="item.isShow == 2"
                class="list-body d-flex align-items-start mg-b-10"
              >
                <div class="d-flex justify-content-center">
                  <label class="ckbox mg-b-0">
                    <input
                      type="checkbox"
                      :value="item.id"
                      v-model="checkArr"
                    />
                    <span></span>
                  </label>
                </div>
                <div class="flex-1 pd-x-0 mg-x-5">
                  <div class="card bd-gray-400 pd-5">
                    <div
                      class="
                        d-flex
                        flex-row
                        align-items-center
                        justify-content-start
                      "
                    >
                      <div class="c-10">
                        <span
                          class="tx-white tx-ellipsis2"
                          style="
                            max-width: 100%;
                            display: inline-block;
                            word-break: break-all;
                          "
                          >{{ item.name }}</span
                        >
                        <div
                          class="td-collapse mg-t-10"
                          :class="{ active: openInner[index] }"
                        >
                          <a
                            href="javascript:;"
                            class="tx-info"
                            @click="innerTableStatus(index)"
                          >
                            <i
                              class="fa tx-white"
                              :class="
                                openInner[index]
                                  ? 'fa-minus-square'
                                  : 'fa-plus-square'
                              "
                            ></i>
                            {{
                              openInner[index]
                                ? $t("mall.折叠子标签")
                                : $t("mall.展开子标签")
                            }}
                          </a>
                        </div>
                      </div>
                      <div class="c-5" style="padding-left: 20px">
                        <a
                          v-if="item.skuCnt > 0"
                          href="javascript:;"
                          class="tx-info"
                          @click="getProductByCid(item)"
                          >{{ item.skuCnt }}</a
                        >
                        <a v-else href="javascript:;" class="tx-info">0</a>
                      </div>
                      <div v-if="item.id != 999999999" class="c-5">
                        <a
                          style="height: 26px"
                          href="javascript:;"
                          class="toggle-wrapper"
                          @click="togglesChange(item)"
                          :class="{ toggles_on: item.isShow == 1 }"
                        >
                          <div class="toggle toggle-light primary">
                            <div class="toggle-slide">
                              <div class="toggle-inner">
                                <div class="toggle-on">{{ $t("mall.是") }}</div>
                                <div class="toggle-blob"></div>
                                <div class="toggle-off">
                                  {{ $t("mall.否") }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </a>
                      </div>
                      <div v-if="item.id != 999999999" class="c-4">
                        <div>
                          <a
                            href="javascript:;"
                            class="tx-info mg-r-15"
                            @click="move(item, '1')"
                            >{{ $t("mall.上移") }}</a
                          >
                          <a
                            href="javascript:;"
                            class="tx-info mg-r-15"
                            @click="move(item, '2')"
                            >{{ $t("mall.下移") }}</a
                          >
                          <a
                            v-if="
                              isSysRights(
                                'SupplierProductCategorys.changeBySupplier'
                              )
                            "
                            href="javascript:;"
                            class="tx-info"
                            @click="addNew(item)"
                            >{{ $t("mall.修改") }}</a
                          >
                        </div>
                        <div>
                          <a
                            href="javascript:;"
                            class="tx-info mg-r-15"
                            @click="addNew(item, 'sub')"
                            >{{ $t("mall.添加子标签") }}</a
                          >
                          <a
                            v-if="
                              isSysRights(
                                'SupplierProductCategorys.deleteBySupplier'
                              )
                            "
                            href="javascript:;"
                            class="tx-danger"
                            @click="deletes(item)"
                            >{{ $t("mall.删除") }}</a
                          >
                        </div>
                        <div>
                          <a
                            v-if="
                              isSysRights('SupplierProductCategorys.copyByCid')
                            "
                            href="javascript:;"
                            class="tx-info"
                            @click="addLabel(item)"
                            >{{ $t("mall.复制商品到其他标签") }}</a
                          >
                        </div>
                      </div>
                    </div>
                    <div>
                      <div
                        v-if="item.chlidren && item.chlidren.length > 0"
                        :style="{
                          display: openInner[index] ? 'block' : 'none',
                        }"
                      >
                        <div class="">
                          <template
                            v-for="(stock, stockIndex) in item.chlidren"
                          >
                            <div
                              class="order-pro bg-sub mg-t-5 mg-l-20"
                              :key="stock.id"
                              v-if="stock.isShow == 2"
                            >
                              <div
                                :class="{ 'bg-sub2': stockIndex % 2 }"
                                class="
                                  bg-sub1
                                  pd-y-5
                                  d-flex
                                  flex-row
                                  align-items-center
                                  justify-content-start
                                  pos-relative
                                "
                              >
                                <div class="c-10 d-flex align-items-center">
                                  <span class="tx-white">{{ stock.name }}</span>
                                </div>
                                <div class="c-5">
                                  <a
                                    v-if="stock.skuCnt > 0"
                                    href="javascript:;"
                                    class="tx-info"
                                    @click="getProductByCid(stock)"
                                    >{{ stock.skuCnt }}</a
                                  >
                                  <a v-else href="javascript:;" class="tx-info"
                                    >0</a
                                  >
                                </div>
                                <div class="c-5">
                                  <a
                                    v-if="item.isShow == 1"
                                    style="height: 26px"
                                    href="javascript:;"
                                    class="toggle-wrapper"
                                    @click="togglesChange(stock)"
                                    :class="{ toggles_on: stock.isShow == 1 }"
                                  >
                                    <div class="toggle toggle-light primary">
                                      <div class="toggle-slide">
                                        <div class="toggle-inner">
                                          <div class="toggle-on">
                                            {{ $t("mall.是") }}
                                          </div>
                                          <div class="toggle-blob"></div>
                                          <div class="toggle-off">
                                            {{ $t("mall.否") }}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </a>
                                </div>
                                <div class="c-4">
                                  <div>
                                    <a
                                      href="javascript:;"
                                      class="tx-info mg-r-30"
                                      @click="move(stock, '1')"
                                      >{{ $t("mall.上移") }}</a
                                    >
                                    <a
                                      href="javascript:;"
                                      class="tx-info"
                                      @click="move(stock, '2')"
                                      >{{ $t("mall.下移") }}</a
                                    >
                                  </div>
                                  <div>
                                    <a
                                      v-if="
                                        isSysRights(
                                          'SupplierProductCategorys.changeBySupplier'
                                        )
                                      "
                                      href="javascript:;"
                                      class="tx-info mg-r-30"
                                      @click="editSub(item, stock)"
                                      >{{ $t("mall.修改") }}</a
                                    >
                                    <a
                                      v-if="
                                        isSysRights(
                                          'SupplierProductCategorys.deleteBySupplier'
                                        )
                                      "
                                      href="javascript:;"
                                      class="tx-danger"
                                      @click="deletes(stock)"
                                      >{{ $t("mall.删除") }}</a
                                    >
                                  </div>
                                  <div>
                                    <a
                                      v-if="
                                        isSysRights(
                                          'SupplierProductCategorys.copyByCid'
                                        )
                                      "
                                      href="javascript:;"
                                      class="tx-info"
                                      @click="addLabel(stock)"
                                      >{{ $t("mall.复制商品到其他标签") }}</a
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                          </template>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <div
              v-if="isShowFLag2 == 0 && !first_loading"
              class="col-12 none-product"
            >
              <i class="fa fa-ban"></i>{{ $t("mall.没有符合条件的标签") }}
            </div>
          </template>
          <template v-else-if="keyName">
            <template v-for="(item, index) in items">
              <div
                :key="item.id + index"
                v-if="item.keyNameShow"
                class="list-body d-flex align-items-start mg-b-10"
              >
                <div class="d-flex justify-content-center">
                  <label class="ckbox mg-b-0">
                    <input
                      type="checkbox"
                      :value="item.id"
                      v-model="checkArr"
                    />
                    <span></span>
                  </label>
                </div>
                <div class="flex-1 pd-x-0 mg-x-5">
                  <div class="card bd-gray-400 pd-5">
                    <div
                      class="
                        d-flex
                        flex-row
                        align-items-center
                        justify-content-start
                      "
                    >
                      <div class="c-10">
                        <span
                          class="tx-white tx-ellipsis2"
                          style="
                            max-width: 100%;
                            display: inline-block;
                            word-break: break-all;
                          "
                          >{{ item.name }}</span
                        >
                        <div
                          class="td-collapse mg-t-10"
                          :class="{ active: openInner[index] }"
                        >
                          <a
                            href="javascript:;"
                            class="tx-info"
                            @click="innerTableStatus(index)"
                          >
                            <i
                              class="fa tx-white"
                              :class="
                                openInner[index]
                                  ? 'fa-minus-square'
                                  : 'fa-plus-square'
                              "
                            ></i>
                            {{
                              openInner[index]
                                ? $t("mall.折叠子标签")
                                : $t("mall.展开子标签")
                            }}
                          </a>
                        </div>
                      </div>
                      <div class="c-5" style="padding-left: 20px">
                        <a
                          v-if="item.skuCnt > 0"
                          href="javascript:;"
                          class="tx-info"
                          @click="getProductByCid(item)"
                          >{{ item.skuCnt }}</a
                        >
                        <a v-else href="javascript:;" class="tx-info">0</a>
                      </div>
                      <div v-if="item.id != 999999999" class="c-5">
                        <a
                          style="height: 26px"
                          href="javascript:;"
                          class="toggle-wrapper"
                          @click="togglesChange(item)"
                          :class="{ toggles_on: item.isShow == 1 }"
                        >
                          <div class="toggle toggle-light primary">
                            <div class="toggle-slide">
                              <div class="toggle-inner">
                                <div class="toggle-on">{{ $t("mall.是") }}</div>
                                <div class="toggle-blob"></div>
                                <div class="toggle-off">
                                  {{ $t("mall.否") }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </a>
                      </div>
                      <div v-if="item.id != 999999999" class="c-4">
                        <div>
                          <a
                            href="javascript:;"
                            class="tx-info mg-r-15"
                            @click="move(item, '1')"
                            >{{ $t("mall.上移") }}</a
                          >
                          <a
                            href="javascript:;"
                            class="tx-info mg-r-15"
                            @click="move(item, '2')"
                            >{{ $t("mall.下移") }}</a
                          >
                          <a
                            v-if="
                              isSysRights(
                                'SupplierProductCategorys.changeBySupplier'
                              )
                            "
                            href="javascript:;"
                            class="tx-info"
                            @click="addNew(item)"
                            >{{ $t("mall.修改") }}</a
                          >
                        </div>
                        <div>
                          <a
                            href="javascript:;"
                            class="tx-info mg-r-15"
                            @click="addNew(item, 'sub')"
                            >{{ $t("mall.添加子标签") }}</a
                          >
                          <a
                            v-if="
                              isSysRights(
                                'SupplierProductCategorys.deleteBySupplier'
                              )
                            "
                            href="javascript:;"
                            class="tx-danger"
                            @click="deletes(item)"
                            >{{ $t("mall.删除") }}</a
                          >
                        </div>
                        <div>
                          <a
                            v-if="
                              isSysRights('SupplierProductCategorys.copyByCid')
                            "
                            href="javascript:;"
                            class="tx-info"
                            @click="addLabel(item)"
                            >{{ $t("mall.复制商品到其他标签") }}</a
                          >
                        </div>
                      </div>
                    </div>
                    <div>
                      <div
                        v-if="item.chlidren && item.chlidren.length > 0"
                        :style="{
                          display: openInner[index] ? 'block' : 'none',
                        }"
                      >
                        <div class="">
                          <div
                            class="order-pro bg-sub mg-t-5 mg-l-20"
                            v-for="(stock, stockIndex) in item.chlidren"
                            :key="stock.id"
                          >
                            <div
                              :class="{ 'bg-sub2': stockIndex % 2 }"
                              class="
                                bg-sub1
                                pd-y-5
                                d-flex
                                flex-row
                                align-items-center
                                justify-content-start
                                pos-relative
                              "
                            >
                              <div class="c-10 d-flex align-items-center">
                                <span class="tx-white">{{ stock.name }}</span>
                              </div>
                              <div class="c-5">
                                <a
                                  v-if="stock.skuCnt > 0"
                                  href="javascript:;"
                                  class="tx-info"
                                  @click="getProductByCid(stock)"
                                  >{{ stock.skuCnt }}</a
                                >
                                <a v-else href="javascript:;" class="tx-info"
                                  >0</a
                                >
                              </div>
                              <div class="c-5">
                                <a
                                  v-if="item.isShow == 1"
                                  style="height: 26px"
                                  href="javascript:;"
                                  class="toggle-wrapper"
                                  @click="togglesChange(stock)"
                                  :class="{ toggles_on: stock.isShow == 1 }"
                                >
                                  <div class="toggle toggle-light primary">
                                    <div class="toggle-slide">
                                      <div class="toggle-inner">
                                        <div class="toggle-on">
                                          {{ $t("mall.是") }}
                                        </div>
                                        <div class="toggle-blob"></div>
                                        <div class="toggle-off">
                                          {{ $t("mall.否") }}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </a>
                              </div>
                              <div class="c-4">
                                <div>
                                  <a
                                    href="javascript:;"
                                    class="tx-info mg-r-30"
                                    @click="move(stock, '1')"
                                    >{{ $t("mall.上移") }}</a
                                  >
                                  <a
                                    href="javascript:;"
                                    class="tx-info"
                                    @click="move(stock, '2')"
                                    >{{ $t("mall.下移") }}</a
                                  >
                                </div>
                                <div>
                                  <a
                                    v-if="
                                      isSysRights(
                                        'SupplierProductCategorys.changeBySupplier'
                                      )
                                    "
                                    href="javascript:;"
                                    class="tx-info mg-r-30"
                                    @click="editSub(item, stock)"
                                    >{{ $t("mall.修改") }}</a
                                  >
                                  <a
                                    v-if="
                                      isSysRights(
                                        'SupplierProductCategorys.deleteBySupplier'
                                      )
                                    "
                                    href="javascript:;"
                                    class="tx-danger"
                                    @click="deletes(stock)"
                                    >{{ $t("mall.删除") }}</a
                                  >
                                </div>
                                <div>
                                  <a
                                    v-if="
                                      isSysRights(
                                        'SupplierProductCategorys.copyByCid'
                                      )
                                    "
                                    href="javascript:;"
                                    class="tx-info"
                                    @click="addLabel(stock)"
                                    >{{ $t("mall.复制商品到其他标签") }}</a
                                  >
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <div
              v-if="isShowFLag3 == 0 && !first_loading"
              class="col-12 none-product"
            >
              <i class="fa fa-ban"></i>{{ $t("mall.没有符合条件的标签") }}
            </div>
          </template>
        </template>
        <template v-else>
          <div
            v-for="(item, index) in items"
            :key="item.id + index"
            class="list-body d-flex align-items-start mg-b-10"
          >
            <div class="d-flex justify-content-center">
              <label class="ckbox mg-b-0">
                <input type="checkbox" :value="item.id" v-model="checkArr" />
                <span></span>
              </label>
            </div>
            <div class="flex-1 pd-x-0 mg-x-5">
              <div class="card bd-gray-400 pd-5">
                <div
                  class="
                    d-flex
                    flex-row
                    align-items-center
                    justify-content-start
                  "
                >
                  <div class="c-10">
                    <span
                      class="tx-white tx-ellipsis2"
                      style="
                        max-width: 100%;
                        display: inline-block;
                        word-break: break-all;
                      "
                      >{{ item.name }}</span
                    >
                    <div
                      class="td-collapse mg-t-10"
                      :class="{ active: openInner[index] }"
                    >
                      <a
                        href="javascript:;"
                        class="tx-info"
                        @click="innerTableStatus(index)"
                      >
                        <i
                          class="fa tx-white"
                          :class="
                            openInner[index]
                              ? 'fa-minus-square'
                              : 'fa-plus-square'
                          "
                        ></i>
                        {{
                          openInner[index]
                            ? $t("mall.折叠子标签")
                            : $t("mall.展开子标签")
                        }}
                      </a>
                    </div>
                  </div>
                  <div class="c-5" style="padding-left: 20px">
                    <a
                      v-if="item.skuCnt > 0"
                      href="javascript:;"
                      class="tx-info"
                      @click="getProductByCid(item)"
                      >{{ item.skuCnt }}</a
                    >
                    <a v-else href="javascript:;" class="tx-info">0</a>
                  </div>
                  <div v-if="item.id != 999999999" class="c-5">
                    <a
                      style="height: 26px"
                      href="javascript:;"
                      class="toggle-wrapper"
                      @click="togglesChange(item)"
                      :class="{ toggles_on: item.isShow == 1 }"
                    >
                      <div class="toggle toggle-light primary">
                        <div class="toggle-slide">
                          <div class="toggle-inner">
                            <div class="toggle-on">{{ $t("mall.是") }}</div>
                            <div class="toggle-blob"></div>
                            <div class="toggle-off">{{ $t("mall.否") }}</div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div v-if="item.id != 999999999" class="c-4">
                    <div>
                      <a
                        href="javascript:;"
                        class="tx-info mg-r-15"
                        @click="move(item, '1')"
                        >{{ $t("mall.上移") }}</a
                      >
                      <a
                        href="javascript:;"
                        class="tx-info mg-r-15"
                        @click="move(item, '2')"
                        >{{ $t("mall.下移") }}</a
                      >
                      <a
                        v-if="
                          isSysRights(
                            'SupplierProductCategorys.changeBySupplier'
                          )
                        "
                        href="javascript:;"
                        class="tx-info"
                        @click="addNew(item)"
                        >{{ $t("mall.修改") }}</a
                      >
                    </div>
                    <div>
                      <a
                        href="javascript:;"
                        class="tx-info mg-r-15"
                        @click="addNew(item, 'sub')"
                        >{{ $t("mall.添加子标签") }}</a
                      >
                      <a
                        v-if="
                          isSysRights(
                            'SupplierProductCategorys.deleteBySupplier'
                          )
                        "
                        href="javascript:;"
                        class="tx-danger"
                        @click="deletes(item)"
                        >{{ $t("mall.删除") }}</a
                      >
                    </div>
                    <div>
                      <a
                        v-if="isSysRights('SupplierProductCategorys.copyByCid')"
                        href="javascript:;"
                        class="tx-info"
                        @click="addLabel(item)"
                        >{{ $t("mall.复制商品到其他标签") }}</a
                      >
                    </div>
                  </div>
                </div>
                <div>
                  <div
                    v-if="item.chlidren && item.chlidren.length > 0"
                    :style="{ display: openInner[index] ? 'block' : 'none' }"
                  >
                    <div class="">
                      <div
                        class="order-pro bg-sub mg-t-5 mg-l-20"
                        v-for="(stock, stockIndex) in item.chlidren"
                        :key="stock.id"
                      >
                        <div
                          :class="{ 'bg-sub2': stockIndex % 2 }"
                          class="
                            bg-sub1
                            pd-y-5
                            d-flex
                            flex-row
                            align-items-center
                            justify-content-start
                            pos-relative
                          "
                        >
                          <div class="c-10 d-flex align-items-center">
                            <span class="tx-white">{{ stock.name }}</span>
                          </div>
                          <div class="c-5">
                            <a
                              v-if="stock.skuCnt > 0"
                              href="javascript:;"
                              class="tx-info"
                              @click="getProductByCid(stock)"
                              >{{ stock.skuCnt }}</a
                            >
                            <a v-else href="javascript:;" class="tx-info">0</a>
                          </div>
                          <div class="c-5">
                            <a
                              v-if="item.isShow == 1"
                              style="height: 26px"
                              href="javascript:;"
                              class="toggle-wrapper"
                              @click="togglesChange(stock)"
                              :class="{ toggles_on: stock.isShow == 1 }"
                            >
                              <div class="toggle toggle-light primary">
                                <div class="toggle-slide">
                                  <div class="toggle-inner">
                                    <div class="toggle-on">
                                      {{ $t("mall.是") }}
                                    </div>
                                    <div class="toggle-blob"></div>
                                    <div class="toggle-off">
                                      {{ $t("mall.否") }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </a>
                          </div>
                          <div class="c-4">
                            <div>
                              <a
                                href="javascript:;"
                                class="tx-info mg-r-30"
                                @click="move(stock, '1')"
                                >{{ $t("mall.上移") }}</a
                              >
                              <a
                                href="javascript:;"
                                class="tx-info"
                                @click="move(stock, '2')"
                                >{{ $t("mall.下移") }}</a
                              >
                            </div>
                            <div>
                              <a
                                v-if="
                                  isSysRights(
                                    'SupplierProductCategorys.changeBySupplier'
                                  )
                                "
                                href="javascript:;"
                                class="tx-info mg-r-30"
                                @click="editSub(item, stock)"
                                >{{ $t("mall.修改") }}</a
                              >
                              <a
                                v-if="
                                  isSysRights(
                                    'SupplierProductCategorys.deleteBySupplier'
                                  )
                                "
                                href="javascript:;"
                                class="tx-danger"
                                @click="deletes(stock)"
                                >{{ $t("mall.删除") }}</a
                              >
                            </div>
                            <div>
                              <a
                                v-if="
                                  isSysRights(
                                    'SupplierProductCategorys.copyByCid'
                                  )
                                "
                                href="javascript:;"
                                class="tx-info"
                                @click="addLabel(stock)"
                                >{{ $t("mall.复制商品到其他标签") }}</a
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <div
          v-if="(!items || items.length < 1) && !first_loading"
          class="col-12 none-product"
        >
          <i class="fa fa-ban"></i>{{ $t("mall.没有符合条件的标签") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["first_loading", "items", "isAccordion", "keyStatus", "keyName"],
  data() {
    return {
      statusClass: {
        1: "tx-warning",
        2: "tx-success",
        9: "tx-danger",
      },
      openInner: [],
      checkArr: [],
      isShowFLag1: 0,
      isShowFLag2: 0,
      isShowFLag3: 0,
    };
  },
  filters: {
    dateFormat(date) {
      return moment(date, "YYYYMMDD").format("YYYY-MM-DD");
    },
  },
  computed: {
    allCheck() {
      return this.checkArr.length == this.items.length &&
        this.checkArr.length > 0
        ? true
        : false;
    },
  },
  watch: {
    isAccordion: function () {
      //$t('mall.展开折叠')
      this.openInnerFormat();
    },
    items: function () {
      this.openInnerFormat();
      this.itemsFormat();
    },
  },
  methods: {
    itemsFormat() {
      let num3 = 0;
      if (!this.keyName || !this.items.length) return;
      this.items.forEach((e) => {
        this.$set(e, "keyNameShow", false);
        console.log(e.name.indexOf(this.keyName));
        if (e.name.indexOf(this.keyName) != -1) {
          this.$set(e, "keyNameShow", true);
        }
        if (!e.keyNameShow) {
          if (e.chlidren && e.chlidren.length > 0) {
            e.chlidren.forEach((s) => {
              if (s.name.indexOf(this.keyName) != -1) {
                this.$set(e, "keyNameShow", true);
              }
            });
          }
        }
      });
      this.items.forEach((e) => {
        if (e.keyNameShow) {
          num3++;
          this.isShowFLag3 = num3;
        }
      });
    },
    openInnerFormat() {
      let num1 = 0;
      let num2 = 0;
      this.openInner = [];
      for (let i = 0; i < this.items.length; i++) {
        this.openInner.push(false);
        if (this.items[i].chlidren && this.items[i].chlidren.length > 0) {
          this.openInner[i] = !this.isAccordion;
        }
        if (this.items[i].isShow == 1) {
          num1++;
        } else {
          num2++;
        }
      }
      this.isShowFLag1 = num1;
      this.isShowFLag2 = num2;
    },
    innerTableStatus(i) {
      this.$set(this.openInner, i, !this.openInner[i]);
    },
    allCheckChange() {
      if (this.allCheck) {
        this.checkArr = [];
      } else {
        this.checkArr = [];
        this.items.forEach((e) => {
          this.checkArr.push(e.id);
        });
      }
    },
    addNew(item, type) {
      this.$emit("addNew", item, type);
    },
    deletes(item) {
      this.$emit("deletes", item);
    },
    togglesChange(item) {
      this.$emit("togglesChange", item);
    },
    move(item, type) {
      this.$emit("move", item, type);
    },
    addLabel(item) {
      this.$emit("addLabel", item);
    },
    editSub(item, sub) {
      this.$emit("editSub", item, sub);
    },
    getProductByCid(item) {
      this.$emit("getProductByCid", item);
    },
  },
};
</script>
<style scoped="scoped">
.td-collapse.active + td {
  border-left: none;
}
.bg-sub .bg-sub1 {
  overflow: hidden;
}
.bg-sub .bg-sub1 {
  background-color: rgba(0, 0, 0, 0.4);
}
.bg-sub .bg-sub1.bg-sub2 {
  background-color: rgba(0, 0, 0, 0.2);
}
.show-white-style .bg-sub .bg-sub1 {
  background-color: #e6e6e6;
}
.show-white-style .bg-sub .bg-sub1.bg-sub2 {
  background-color: #f6f6f6;
}
.card .order-pro {
  background-color: #1a2432;
  border: 1px solid rgba(255, 255, 255, 0.3);
}
.show-white-style .card .order-pro {
  background-color: #fff;
  border: 1px solid #dee2e6;
}
</style>